import { useQuery } from "@tanstack/react-query";
import { GetDashboardSummary } from "../Api";
import { ServiceQueryOptions, unwrapApiResponse } from "./query_helpers";
import { LOOKUP_STALE_TIME } from "../Constant/AppConstants";

export const dashboardQueryKeys = {
  summary: (params?: any) => ["dashboard", "summary", params] as const,
};

export const useDashboardSummaryQuery = (params?: any, options?: ServiceQueryOptions) => {
  return useQuery({
    staleTime: LOOKUP_STALE_TIME,
    ...options,
    queryKey: dashboardQueryKeys.summary(params),
    queryFn: async () => {
      const res = await GetDashboardSummary(params);
      return unwrapApiResponse(res);
    },
  });
};

export const useDashboardService = (config?: { params?: any }) => {
  const summaryQuery = useDashboardSummaryQuery(config?.params);

  return {
    summaryQuery,
  };
};
